// メインクラス
//import { QuestionPanel } from './QuestionPanel';
//import { TagData } from './TagData';
import { MPUtils } from './MPUtils';
//import { ImageData } from './ImageData';
import { XConverter } from './XUtils';
import { CustomLocationData } from './CustomLocationData';
import { Navigation } from './Navigation';
//import { Starter } from './Starter';
import { Status } from './Status';
import { Mover } from './Mover';


export class Main {
    //要カスタマイズ！ 位置データなど
    stopEnter = false; //'Enter'表示で停止するか？
    locationData = new CustomLocationData(); //位置情報データ

    locationIndex = 0;  //初期位置インデックス
    tagAlphaOn = 1.0; //表示タグのアルファ
    tagAlphaOff = 0.0;  //非表示タグのアルファ

    poseOut = false;
    first = true;
    initialMove = false;    //着地後すぐ移動するか？（Quizコンテンツでの入口への移動）
    mode: string = ''; //前のモード
    status;
    navigation;
    mover;
    //starter;
    iconIDs;
    mpUtils;
    //各コンテンツのパラメータ
    currentTagSets; //選択したコンテンツの有効タグ
    targetTransforms = [];
    // 棟（A,B,C）
    place;
    currentSweepId;

    constructor(public mpSdk, public deploy, public debugLvl, public spaceid, public loc) {
        this.place = this.locationData.GetPlaceFromID(spaceid);
        if (debugLvl > 0) console.log('place:' + this.place);
        //MPユーティリティクラス
        this.mpUtils = new MPUtils(mpSdk);
        this.Main(mpSdk);
    }

    /*
        ---------- 関数定義 ----------
       */
    //タイマコールバック
    public TimerCallback(lapse: number) {
        let timestr = XConverter.MiliSecToDHMSString(lapse, true);
        this.status.TimerOut(timestr);
    }


    //指定したタグアイコンを表示・非表示
    public ShowHideIconGroup(icons, flag) {
        for (let icon of icons) {
            if (this.debugLvl > 2) console.log(typeof (icon.sid), icon.sid, flag);
            if (flag) {
                //表示
                //this.mpUtils.SetTagAlphaOf(icon.sid, this.tagAlphaOn, true);
                this.mpUtils.EnableTagOf(icon.sid, this.tagAlphaOn);
            } else {
                //非表示
                //this.mpUtils.SetTagAlphaOf(icon.sid, this.tagAlphaOff, false);
                this.mpUtils.DisableTagOf(icon.sid, this.tagAlphaOff);
            }
        }
    }

    //タグアイコン画像の設定（iconNameを予めRegisterしておく必要あり）
    public SetIconImages(icons, iconName) {
        for (let icon of icons) {
            this.mpUtils.SetTagImageOf(icon.sid, iconName);
        }
    }

    //モード初期処理 モードは、Initial > Enter > Startと進行
    public setInitial() {
        //ページアクセス直後 トップメニュー、ウェルカムパネル消去
        if (this.debugLvl > 1) console.log('setInitial');
        //this.navigation.Hide();
        this.navigation.HideWelcome();
        this.status.Hide();
        //this.starter.Clear();
    }

    public setEnter() {
        //モードEnter トップメニュー、ウェルカムパネル表示
        if (this.debugLvl > 1) console.log('setEnter');
        if (this.loc != undefined) {
            //初期移動
            if (this.debugLvl > 0) console.log('Initial Move to ' + this.loc);
            this.MoveBy(this.loc);
            //this.loc = undefined;
        } else {
            this.navigation.ShowWelcome();
        }
        this.navigation.Show();
        //this.starter.Clear();
        //this.status.Show();
    }
    //モードStart ENTERボタンクリック、ユーザ操作開始
    //public Start() {
    //    if (this.debugLvl > 1) console.log('START', this.debugLvl);
    //    //スタート(ENTER)ボタン押下
    //    this.MoveTo(0, 'fade', 500);  //現在のコンテンツのindex1に移動
    //}


    //リセットタイマーをクリアし、ENTERモードへ
    public Reset() {
        if (this.debugLvl > 1) console.log('Reset');
        this.MoveTo(0, 'fade', 1000);  //初期位置へ
    }


    //該当コンテンツのタグを抽出
    public ScreenTags(transforms) {
        this.targetTransforms = [];
        // targetTransforms:現在のタグセットのタグ情報（順番を含む）
        for (let tag of this.currentTagSets) {
            for (let tr of transforms) {
                if (tr.sid == tag.sid) {
                    this.targetTransforms.push(tr);
                    break;
                }
            }
        }
        if (this.debugLvl > 2) {
            for (let i = 0; i < this.targetTransforms.length; i++) {
                console.log(i, this.targetTransforms[i].sid);
            }
        }
    }


    //次の位置へ移動する
    public setNext() {
        //次のロケーションに移動
        const location = this.currentTagSets;
        this.locationIndex = XConverter.GetIndexWithLoop(this.locationIndex + 1, location.length - 1);
        if (this.debugLvl > 1) console.log(this.locationIndex);
        this.MoveTo(this.locationIndex);
    }

    //Homeボタンクリック時
    public setHome() {
        //ホームへ戻る
        if (this.debugLvl > 1) console.log('home');
        //this.resetAll();
        this.locationIndex = 0;
        this.MoveTo(this.locationIndex, 'fade', 1000);
    }

    public StartTracking() {
        //カメラ位置の取得（サブスクリプション）の有効化
        if (this.debugLvl > 1) console.log('StartTracking');
        this.mpUtils.PoseMonitor((pose) => this.Mapping(pose));
    }
    public Mapping(pose) {
        if (this.debugLvl > 2) console.log('pose.mode', pose.mode);
        this.ModeCheck(pose.mode);
        this.currentSweepId = pose.sweep;   //現在のSweepID
        //ダミーメソッド
        if (this.debugLvl > 2)
            console.log('{name:\'place\', sweepId:\' ', pose.sweep, '\', rotation:{ x: ', pose.rotation.x.toFixed(3), ', y:', pose.rotation.y.toFixed(3), ' }},');
    }
    public ModeCheck(m) {
        if (m != this.mode) {
            //モードが変わった
            //初期化前かつモードがtransitioningからinsideに移った
            if (this.first == true && this.mode == 'mode.transitioning' && m == 'mode.inside') {
                if (this.debugLvl > 1) console.log('Mode transitioning from ', this.mode, 'to', m);
                this.first = false;
                this.setEnter();
            } else {
                if (this.debugLvl > 1) console.log('Mode Changed from', this.mode, 'to', m);
            }
            this.mode = m;
        }
    }

    // 移動の設定
    public MoveTo(locIndex: number, transition: ('none' | 'fly' | 'fade') = 'fly', transitionTime = 5000) {
        if (this.debugLvl > 1) console.log("Move To ", locIndex);
        const location = this.locationData.locationSets[this.place];
        const sweepId = location[locIndex].sweepId;
        const rotation = location[locIndex].rotation;

        if (sweepId != this.currentSweepId)
            this.mpUtils.MoveTo(sweepId, rotation, transition, transitionTime);
    }

    public MoveBy(pname: string, transition: ('none' | 'fly' | 'fade') = 'fade', transitionTime = 1000) {
        //名前で指定して移動
        if (this.debugLvl > 1) console.log("Move By ", pname, this.place);
        const location = this.locationData.locationSets[this.place];
        if (this.debugLvl > 1) console.log(location.length);
        var locIndex = 0;
        for (let i = 0; i < location.length; i++) {
            if (location[i].name == pname) {
                locIndex = i;
                break;
            }
        }
        const sweepId = location[locIndex].sweepId;
        const rotation = location[locIndex].rotation;

        if (sweepId != this.currentSweepId) {
            this.mpUtils.MoveTo(sweepId, rotation, transition, transitionTime);
            this.navigation.HideMenu(); //移動したらメニューを消去
        }
    }

    public SelectTagByIndex(index) {

        const data = this.currentTagSets;
        if (this.debugLvl > 2) console.log(data);
        for (let i = 0; i < data.length; i++) {
            const sid = data[i].sid;
            if (i == index) {
                this.mpUtils.EnableTagOf(sid, this.tagAlphaOn);
            } else {
                this.mpUtils.DisableTagOf(sid, this.tagAlphaOff);
            }
        }
    }

    /*
     ====== メインルーチン =======
    */
    Main(mpSdk) {
        if (this.debugLvl > 1) console.log(mpSdk);
        // ============================================
        // 全タグの出力
        //let outstr = '';
        mpSdk.Mattertag.getData()
            .then(function (mattertags) {
                if (mattertags.length > 0) {
                    mattertags.forEach(value => console.log("{ sid: \"" + value.sid + "\"\, label: \"" + value.label + "\" },"));
                    //mattertags.forEach(value => outstr = outstr + "{ sid: \"" + value.sid + "\"\, label: \"" + value.label + "\" },\n");
                    //console.log(outstr);
                }
            })
            .catch(function (error) {
                console.log("Can't get MP tags");
                console.log(error);
            })


        //タグSIDの配列を取得
        let mattertagIds = this.mpUtils.GetSIDs();
        if (this.debugLvl > 2) console.log(mattertagIds);
        //MPタグのマウスオーバーに反応しないようにする タグがCLICKされるとPanelSelectorをコール


        //Sweepイベントのリスン
        this.mpUtils.SweepEventListener();

        //タグアイコン画像の登録と画像IDの取得
        //if (this.debugLvl > 2) console.log(ImageData.icons);
        let header = "";
        if (this.debugLvl > 1) console.log('header:' + header);
        if (this.deploy == 'production') header = "../"; //プロダクションサーバーでは１つ下のディレクトリから実行される？
        //this.iconIDs = this.mpUtils.RegisterIcons(ImageData.icons, header);
        //if (this.debugLvl > 1) console.log(this.iconIDs);

        //スタートパネル
        //this.starter = new Starter(() => this.Start(), true);

        //ステータス
        this.status = new Status();

        //ナビゲーション
        this.navigation = new Navigation(() => this.setHome());
        this.mover = new Mover(this.place, (name) => this.MoveBy(name));

        //初期設定
        this.locationIndex = 0;  //開始位置のインデックス（this.locationData.locationSets[])
        //let location = this.locationData.locationSets[this.contentType];  //コンテンツに対応した位置データを取得
        //if (this.debugLvl > 1) console.log(this.contentType, location.length);

        //画面サイズ変更時のマップ再描画
        window.addEventListener('resize', () => {
            //const xDelayTimer = new XDelayTimer();
        });
        window.addEventListener('orientationchange', () => {
            //const xDelayTimer = new XDelayTimer();
        })
        //初期状態へ
        this.first = true; //初期化前
        this.setInitial();
    };
}